import { useEffect, useState, useRef } from "react";
import {
    Button,
    message,
    Form,
    ProTableOt,
    DeletePopHover,
    Popconfirm,
} from "../../ui/ot";
import { Space } from "antd";
import { useCRUDController } from "../../controllers/CRUDController";
import ClassifyStructureModal from "./ClassifyStructureModal";

const Main = ({
    forceReload = 0,
    propsForm = null,
    prefixTitle = "",
    classify_structure_id = 0,
    classify_structure_type_id = 0,
    initialValues = {},
    apiRoute = "",
    extraParams = {},
    customColumns = {},
    customFormItems = () => { },
    onChange = () => { },
    onSubmit = () => { },
    onSortable = () => { },
    deleteNode = () => { },
    onSelect = () => { },
    reorganizeFormData = (value, type) => {
        return { ...value };
    },
    defaultExpandAllRows = true
}) => {
    const columns = [
        // {
        //     title: "中文名稱",
        //     key: "title",
        //     dataIndex: "title",
        //     render: (text, record, index) =>
        //         record[`${languageKey}`]?.find(
        //             (tmp) => tmp.language_culture_code === "zh-tw"
        //         )?.language_culture_value || record.name,
        // },
        // {
        //     title: "英文名稱",
        //     dataIndex: "nameEn",
        //     key: "nameEn",
        //     render: (text, record, index) =>
        //         record[`${languageKey}`]?.find(
        //             (tmp) => tmp.language_culture_code === "en"
        //         )?.language_culture_value || record.name,
        // },
        ...customColumns,
        {
            title: "操作",
            dataIndex: "action",
            width: "40%",
            key: "action",
            render: (text, record, index) => (
                <Space wrap>
                    <Button
                        type="primary"
                        size={"small"}
                        style={{
                            verticalAlign: "middle",
                            backgroundColor: "#2E3840",
                        }}
                        onClick={(e) => {
                            // onSubmit(prefixTitle, languageKey, record)

                            handleAddRow({
                                classify_structure_id: classify_structure_id,
                                classify_structure_type_id: record?.classify_structure_type_id,
                                classify_structure_type_parent_id: record?.classify_structure_type_id,
                            });
                        }}
                    >
                        新增子項目
                    </Button>

                    <Button
                        type="primary"
                        size={"small"}
                        style={{
                            verticalAlign: "middle",
                            backgroundColor: "#4E6E81",
                        }}
                        onClick={() => {
                            handleEditRow("edit", reorganizeFormData(record, "set"));
                        }}
                    >
                        編輯
                    </Button>

                    <DeletePopHover
                        title="刪除項目"
                        description="確定刪除勾選的項目"
                        onConfirm={() => handleDeleteRow(record?.[`${prefixTitle}_id`])}
                        onCancel={() => { }}
                    >
                        <Button
                            type="primary"
                            size={"small"}
                            style={{
                                verticalAlign: "middle",
                                backgroundColor: "#FF6969",
                            }}
                        >
                            刪除
                        </Button>
                    </DeletePopHover>
                </Space>
            ),
        },
    ];
    const [languageKey, setLanguageKey] = useState("");
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[`${prefixTitle}_id`]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[`${prefixTitle}_id`]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[`${prefixTitle}_id`]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[`${prefixTitle}_id`]
                );
                selectRow = selectRow.filter(
                    (row) => row[`${prefixTitle}_id`] !== record?.[`${prefixTitle}_id`]
                );
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const [axiosMode, setAxiosMode] = useState("get");
    const [editTarget, setEditTarget] = useState("edit");
    const [treeData, setTreeData] = useState([]);

    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = ({
        classify_structure_id,
        classify_structure_type_id,
        classify_structure_type_parent_id,
    }) => {
        setAxiosMode("post");
        setModalOpen(true);
        setEditTarget('edit');

        if (propsForm) {
            propsForm.resetFields();
            propsForm.setValue("classify_structure_id", classify_structure_id);
            propsForm.setValue(
                "classify_structure_type_id",
                classify_structure_type_id || 0
            );
            propsForm.setValue(
                "classify_structure_type_parent_id",
                classify_structure_type_parent_id || 0
            );
            if (!!initialValues && typeof initialValues === "object") {
                Object.keys(initialValues).forEach((key) => {
                    propsForm.setValue(key, initialValues[key]);
                });
            }
        } else {
            form.resetFields();
            form.setValue("classify_structure_id", classify_structure_id);
            form.setValue(
                "classify_structure_type_id",
                classify_structure_type_id || 0
            );
            form.setValue(
                "classify_structure_type_parent_id",
                classify_structure_type_parent_id || 0
            );
            if (!!initialValues && typeof initialValues === "object") {
                Object.keys(initialValues).forEach((key) => {
                    form.setValue(key, initialValues[key]);
                });
            }
        }
    };
    const handleEditRow = (editTarget, record) => {
        setAxiosMode("patch");
        setModalOpen(true);
        setEditTarget(editTarget);

        if (editTarget === "edit") {
            if (propsForm) {
                propsForm.resetFields();
                Object.keys(record).forEach((key) => {
                    propsForm.setValue(key, record[key]);
                });
            } else {
                form.resetFields();
                Object.keys(record).forEach((key) => {
                    form.setValue(key, record[key]);
                });
            }
        } else if (editTarget === "sort") {
            form.resetFields();
            setTreeData(ResponseData);
        }
    };
    const handleDeleteRow = (id, classify_structure_type_id) => {
        let data = [];
        if (id) {
            data = [
                {
                    [`${prefixTitle}_id`]: id,
                    classify_structure_id: classify_structure_id,
                    classify_structure_type_id: classify_structure_type_id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    [`${prefixTitle}_id`]: val?.[`${prefixTitle}_id`],
                    classify_structure_id: classify_structure_id,
                    classify_structure_type_id: classify_structure_type_id,
                };
            });
        }
        if (data.length > 0) {
            deleteData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let newValues = reorganizeFormData(values, "submit");
        if (axiosMode === "post") {
            postData(newValues);
        } else if (axiosMode === "patch" && editTarget === "edit") {
            patchData([newValues]);
        } else if (axiosMode === "patch" && editTarget === "sort") {
            patchData(values);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
            if (axiosMode !== "get") {
                setModalLoading(false);
                setModalOpen(false);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useTableColumnsCheck(columns);

    const { ResponseData, getData, postData, patchData, deleteData } =
        useCRUDController({
            onFinish,
            onBefore,
            apiRoute: apiRoute,
        });
    useEffect(() => {
    }, [languageKey]);
    useEffect(() => {
        setLanguageKey(prefixTitle + "_language_data");
    }, [prefixTitle]);
    useEffect(() => {
        // document.title = `${prefixTitle} | `;
        checkAll();
    }, []);
    useEffect(() => {
        if (forceReload !== 0) {
            actionRef.current.reload();
        }
    }, [forceReload])
    return (
        <>
            <ClassifyStructureModal
                axiosMode={axiosMode}
                editTarget={editTarget}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={propsForm ? propsForm : form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
                customFormItems={customFormItems}
                initialTreeData={treeData}
                prefixTitle={prefixTitle}
            // classifyStructureData={}
            />
            {/* <SortableModal
        axiosMode={axiosMode}
        propsOpen={modalOpen}
        propsSetOpen={setModalOpen}
        propsForm={form}
        propsLoading={modalLoading}
        propsSetLoading={setModalLoading}
        onFinish={onFormFinish}
      ></SortableModal> */}
            <ProTableOt
                key={forceReload}
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={[`${prefixTitle}_id`]}
                selections={
                    {
                        // onChange: (index_, data_) => set_data(data_)
                    }
                }
                toolBarRender={() => [
                    <Button
                        type="primary"
                        style={{
                            color: "#000",
                            backgroundColor: "#ffedee",
                        }}
                        onClick={(e) =>
                            handleAddRow({
                                classify_structure_id,
                                classify_structure_type_id,
                            })
                        }
                    >
                        新增項目
                    </Button>,
                    <Button
                        type="primary"
                        style={{
                            color: "#000",
                            backgroundColor: "#ffedee",
                        }}
                        onClick={(e) => handleEditRow("sort")}
                    >
                        項目排序
                    </Button>,
                    <Popconfirm
                        title="刪除項目"
                        description="確定刪除勾選的項目"
                        onConfirm={() => handleDeleteRow()}
                        onCancel={() => { }}
                    >
                        <Button
                            type="primary"
                            style={{
                                color: "#000",
                                backgroundColor: "#ffedee",
                            }}
                        >
                            刪除項目
                        </Button>
                    </Popconfirm>,
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        classify_structure_id: 5,
                        classify_structure_type_id: 0,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        ...extraParams
                    };

                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return getData(newParams);
                    // return {
                    //     data: [
                    //         {
                    //             classify_structure_type_id: 4548,
                    //             value: 4548,
                    //             classify_structure_type_parent_id: 0,
                    //             classify_structure_id: 5,
                    //             title: "形象首頁",
                    //             index: 1,
                    //             background_color: null,
                    //             font_color: null,
                    //             children: [],
                    //             classify_structure_type_file_data: [],
                    //             name: "形象首頁",
                    //             path: "233_形象首頁",
                    //             permission_id: 233,
                    //             path_check: 1,
                    //             subheading: "gbbbbfdfgbg",
                    //             property_json: {
                    //                 blod: true,
                    //                 size: 40,
                    //                 italic: true,
                    //                 textDecoration: true,
                    //                 background_color1: "#1a7861",
                    //                 background_color2: "#c82020",
                    //             },
                    //             show: 1,
                    //             permission_language_data: [
                    //                 {
                    //                     language_manage_id: 557,
                    //                     language_culture_code: "zh-tw",
                    //                     language_culture_value: "形象首頁",
                    //                 },
                    //                 {
                    //                     language_manage_id: 558,
                    //                     language_culture_code: "en",
                    //                     language_culture_value: "Home",
                    //                 },
                    //             ],

                    //             key: 1,
                    //         },
                    //     ],
                    //     total: 1,
                    // };

                    // return []
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: "checkbox",
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    );
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content",
                }}
                defaultExpandAllRows={defaultExpandAllRows}
            />

            {/* </Row> */}
        </>
    );
};

const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};

export default Main;
